module.exports = __webpack_public_path__ + "components/Header/logo-inspire.png?bd7c043b";


//////////////////
// WEBPACK FOOTER
// ./components/Header/logo-inspire.png
// module id = 854
// module chunks = 0